/**
 * © [2024] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React from 'react';
import * as Styles from '../../../../../SharedModules/StyleConstant/StyleConstant';

export const leftRebateProgramHead = [
  {
    headerName: 'Rebate Pgm Cd',
    field: 'rebateProgramCd',
    editable: false,
    sortable: true,
    minWidth: Styles.Width_171,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Short Description',
    field: 'shortDescr',
    editable: false,
    sortable: true,
    minWidth: Styles.Width_150,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    sortingOrder: ['desc', 'asc'],
    cellRenderer: 'TextBoxRender',
    cellClass: 'frr-ellipsis-text',

    cellStyle: { 'border-right-color': Styles.BorderColor },
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: '',
    field: 'longDescr',
    editable: false,
    sortable: false,
    hideFilterIcon: true,

    minWidth: Styles.Width_200,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    sortingOrder: ['desc', 'asc'],
    cellRenderer: 'TextBoxRender',
    cellClass: 'frr-ellipsis-text',
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
];
export const rightRebateProgramHead = [
  {
    headerName: 'Rebate Pgm Cd',
    field: 'rebateProgramCd',
    editable: false,
    sortable: true,
    minWidth: Styles.Width_171,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Short Description',
    field: 'shortDescr',
    editable: false,
    sortable: true,
    minWidth: Styles.Width_150,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    cellRenderer: 'TextBoxRender',
    cellClass: 'frr-ellipsis-text',
    sortingOrder: ['desc', 'asc'],
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: '',
    field: 'longDescr',
    editable: false,
    sortable: false,
    hideFilterIcon: true,
    minWidth: Styles.Width_200,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    sortingOrder: ['desc', 'asc'],
    cellRenderer: 'TextBoxRender',
    cellClass: 'frr-ellipsis-text',
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
];
